<template>
  <header class="container-fluid">
    <nav class="row">
      <div class="col-12 text-center">
        <a href="index.html">
          <img
            src="../../assets/svg/nav-logo.svg"
            class="img-fluid nav-logo"
            alt="Resource app navigation logo"
          />
        </a>
      </div>
    </nav>
  </header>
</template>

<style scoped>
header {
  margin-top: 24px;
}

.nav-logo {
  height: 40px;
}
</style>
